import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.space.Record.Filter.DimensionFilter,
  graphql.schema.SpaceRecordsDimensionFilterInput
>({
  entityId: graphql.transformers.IN.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Entity.Id.isId,
    { warnOnly: true },
  ),
  recordIds: graphql.transformers.IN.list(
    graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      ents.core.dms.data.Record.Id.isId,
      { warnOnly: true },
    ),
    { onNullish: 'remove' },
  ),
})
